import { createFileRoute } from '@tanstack/react-router';
import { useEffect, useState } from 'react';
import { DashboardHome } from '~/components/DashboardHome/DashboardHome';
import styles from '~/components/DashboardHome/DashboardHome.module.css';
import { tenantCurrency } from '~/lib/capabilities';
import { useDashboardPeriod } from '~/lib/dashboard-period';
import { useDashboardAttention, useDashboardData } from '~/lib/dashboard-queries';
import { usePipelines } from '~/lib/queries';
import { useMyTaskCounts } from '~/lib/tasks-queries';
import { useTenantContext } from '~/lib/tenantContext';

export const Route = createFileRoute('/_authed/')({
  component: DashboardPage,
});

function DashboardPage() {
  const { selectedTenant } = useTenantContext();
  const [period, setPeriod] = useDashboardPeriod();
  const { data: pipelines = [] } = usePipelines();
  const [funnelPipelineId, setFunnelPipelineId] = useState<string | null>(null);

  useEffect(() => {
    if (pipelines.length === 0) {
      setFunnelPipelineId(null);
      return;
    }
    if (funnelPipelineId && pipelines.some((pipeline) => pipeline.id === funnelPipelineId)) return;
    const preferred = pipelines.find((pipeline) => pipeline.is_default) ?? pipelines[0];
    setFunnelPipelineId(preferred?.id ?? null);
  }, [pipelines, funnelPipelineId]);

  const { data, isLoading, error } = useDashboardData({ funnelPipelineId, period });
  const { data: tasks } = useMyTaskCounts();
  const { data: attention } = useDashboardAttention();

  if (!selectedTenant) {
    return (
      <div className={styles.dashboard}>
        <header className="page-header">
          <h1 className="h2">Dashboard</h1>
        </header>
        <div className={styles.empty}>Selecciona un cliente en el switcher del topbar.</div>
      </div>
    );
  }

  return (
    <DashboardHome
      tenantName={selectedTenant.name}
      currency={tenantCurrency(selectedTenant)}
      period={period}
      onPeriodChange={setPeriod}
      pipelines={pipelines}
      funnelPipelineId={funnelPipelineId}
      onPipelineChange={setFunnelPipelineId}
      data={data}
      loading={isLoading}
      error={error}
      tasks={tasks}
      attention={attention}
    />
  );
}
